<template>
    <div class="countdown" :style="{fontSize: fontSize+'px'}">
        <slot></slot>
        {{ count }}s
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, defineEmits, defineProps } from 'vue'

const props = defineProps({
    from: {
        type: Number,
        required: true
    },
    size: {
        type: Number,
        required: false,
        default: 40
    }
})

const emit = defineEmits(['onfinished', 'onchange'])

const count = ref(props.from)
const fontSize = ref(props.size)
const countdown = () => {
    if (count.value > 1) {
        count.value--
        emit('onchange', count.value)
    } else {
        emit('onfinished')
        clearInterval(interval)
    }
}

let interval

onMounted(() => {
    interval = setInterval(countdown, 1000)
})

onUnmounted(() => {
    clearInterval(interval)
})
</script>

<style scoped>
.countdown {
    margin: 100px auto 0; /* Marginaler som du angav */
    
    /* --- Färg och Typsnitt --- */
    font-family: var(--font-terminal); /* Använd retro-fonten */
    color: var(--color-primary);       /* Använd den gröna terminalfärgen */
    font-size: 5rem;                   /* Gör den större för extra effekt */
    line-height: 1;                    /* Säkerställ att texten inte har för stort radavstånd */
    
    /* --- Glöd --- */
    /* Ge texten en starkare, pulserande glöd */
    text-shadow: 0 0 10px var(--color-primary), 
                 0 0 20px var(--color-primary); 
    
    text-align: center;
    
    /* --- Extra: Liten "pulserande" effekt för att dra uppmärksamhet --- */
    animation: countdown-pulse 1.5s infinite alternate;
}

/* Keyframes för den pulserande glöden */
@keyframes countdown-pulse {
    from {
        /* Svagare glöd */
        text-shadow: 0 0 8px var(--color-primary), 
                     0 0 15px var(--color-primary);
    }
    to {
        /* Starkare glöd */
        text-shadow: 0 0 12px var(--color-primary), 
                     0 0 25px var(--color-primary), 
                     0 0 35px rgba(0, 255, 65, 0.5); /* Lägg till extra dimmig yttre glöd */
    }
}
</style>% 